import classes from './NeedToUpdateCustomerInfo.scss';
import SceButton from '../../Common/CommonComponents/sceButton.js';
import { getLocalizedStrings } from '../centralizedLocalizedString';
import ReactHtmlParser from 'react-html-parser';
  const NeedToUpdateCustomerInfo = (props) => {
  const strings = getLocalizedStrings('contentSection');
  let bpName=app.appService.getSessionstorage('bpName');
  let customerData=app.appService.getSessionstorage('customerData');
  let name= props.guestUser ? bpName.split(",") : [props.lastName, props.firstName];
  let fName=name[1] ? name[1].toLowerCase() : '';
  let firstName=fName.charAt(0).toUpperCase()+fName.substring(1,fName.length);
  let lName=name[0] ? name[0].toLowerCase() : '';
  let lastName=lName.charAt(0).toUpperCase()+lName.substring(1,lName.length);

  var LanguageConstants = app.appUtil.getLanguageConstants();
   let language = LanguageConstants[props.language];
   let primaryEmailId='';
 
   if (customerData.emailAddresses.length) {
    let filtered =customerData.emailAddresses;
    filtered.map((emailSearch) => {
    if (emailSearch.standardIndicatorEmail === "X") {
    primaryEmailId = emailSearch.email; 
    }
    });
    }
    primaryEmailId = props.guestUser ? primaryEmailId : props.emailId;
   let maskedemail = primaryEmailId.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
  
  return (
    <div className={classes.sceContainerStyle}>
      <div className={classes.sceCustomerAccountView}>
        <div className={classes.sceMainHeading}>
          {strings.NeedToUpdateheader}
        </div>
        <div className={classes.sceText}>
          <p>{firstName} {lastName}</p>
          <p>{maskedemail}</p>
          <p>{strings.LanguageLabel} {language}</p>
        </div>
        <div className={classes.sceText}>
           <SceButton
            id="manageAccountSettings"
            iconType="rightArrow"
            buttonType="sceFullPrimary"
            value={strings.ManageAccSettingsBtn}
            onClick={() => {
              window.aUtils.sendAAEvent("button","manageProfileSettings");
              app.appUtil.navigateTo(app.appUtil.getAppRoutes().BILLING.SETTINGS_PROFILE);
              }
              }
          />
        </div>
      </div>

    </div>
  );
};
export default NeedToUpdateCustomerInfo;